import { validateFolderName, VALIDATION_PRESETS } from './folderValidation';

export const BLOCKED_EMAILS = {
  FromEmail: "ascent360@ascent360.net",
  ReplyToEmail: "ascent360@ascent360.net",
  ErrorMessage:
    "Your Ascent360 email setup is not complete, please work with your Ascent360 support team member to finalize setup before proceeding.",
};
export const TOP_BOTTOM_ENUM = {
  Currency: "Currency",
  CurrencyWithOutDecimal: "CurrencyWithOutDecimal",
  Percentage: "Percentage",
  Numeric: "Numeric",
  Text: "Text",
};

export const EmailSendTypes =
{
    Standard : 1,
    Triggered : 2,
    ListSend : 3,
    AbandonedCart : 4
}

export const DesignViewModes = 
{
    LargeTiles: 0,
    SmallTiles: 1,
    ListView: 2
}

export const DesignTypes = 
{
    Templates: "templates",
    Forms: "forms",
    SMS: "sms"
}

export const CONFIGURATION_TYPES = {
  FromEmail: "FromEmail",
  ReplyToEmail: "ReplyToEmail",
  SeedList: "SeedList",
  TestList: "TestList",
  TrackingParameter: "TrackingParameter",
  FromName: "FromName",
  AddSeedList: "AddSeedList",
  AddTestList: "AddTestList",
  AppendTrackingParameters: "AppendTrackingParameters",
  SMSFromNumber: "FromNumber",
  SMSHelpEmail: "HelpEmail",
  SMSSeedList: "SeedList",
  SMSTestList: "TestList",
  //TrackingParameter: "TrackingParameter",
  SMSFromName: "FromName",
  SMSAddSeedList: "AddSeedList",
  SMSAddTestList: "AddTestList",
  //AppendTrackingParameters: "AppendTrackingParameters",
};

export const TOP_10_CUSTOMERS_ENUM = {
  Spend: "Spend",
  AOV: "AOV",
  Frequency: "Frequency",
};

export const ExternalIntegrationProvider = [
  {
    id: 59,
    Name: "Lightspeed POS",
  },
  {
    id: 61,
    Name: "Lightspeed E-Commerce",
  },
  {
    id: 66,
    Name: "Shopify",
  },
  {
    id: 71,
    Name: "BigCommerce",
  },
];

export const NotAllowedFolderNames = {
  Name: "LIGHTSPEEDECOM",
  Message: "Folder with this name is not allowed.",
};

export const PAGES = {
  DatabaseOverview: "DatabaseOverview",
  Demographic: "Demographic",
  topandbottomcustomers: "topandbottomcustomers",
  Contactability: "Contactability",
  RFM: "RFM",
  DataQuality: "DataQuality",
  DataSource: "DataSource",
  Geography: "Geography",
  all: "all",
};

export const Route = {
  DatabaseOverview: "databaseoverview",
  FileManagement: "filemanagement",
  Configuration: "configuration",
  CustomerLookup: "customerlookup",
  EmailReportsConglom: "emailreportsconglom",
};

export const MergeTagTypeEnum = {
  Default: "default",
  PageScrapeURL: "page_scrape_url",
  MailingSendDate: "mailing_send_date",
};

export const baseUrl = import.meta.env.VITE_BASE_URL + import.meta.env.VITE_WEBCLIENT;
export const VNEXT_BASE_URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API);
export const DEMO_CLIENT_IDS = import.meta.env.VITE_DEMO_CLIENT_IDS;
export const CONT_BASE_URL =import.meta.env.VITE_BASE_URL + import.meta.env.VITE_WEBCLIENT;
export const MARKETING_PLAY_CONFIGURATION_BASE_URL = VNEXT_BASE_URL + "Configuration/MarketingPlayConfiguration/";
export const AVAILABLE_PLAYS_BASE_URL = VNEXT_BASE_URL + "Marketing/AvailablePlays/";
export const BASE_URL = import.meta.env.VITE_BASE_URL + import.meta.env.VITE_WEBCLIENT;
export const EMAIL_DESIGNER_AUTO_SAVE_DURATION = 5000;
export const mergeTagRegex = "{{(.*?)}}";

export const userPermissionsEnum = {
  None: 0,
  Read: 1,
  Write: 2,
  Modify: 3,
  Delete: 4,
  FullAccess: 5,
};

export const emailStatus = {
  Draft: "Draft",
  Sent: "Sent",
  Paused: "Paused",
  Recurring: "Recurring",
  Scheduled: "Scheduled",
  Disabled: "Disabled",
  Live: "Live",
  Completed: "Completed",
  Triggered: "Triggered",
  ListSend:"List Send",
  Sending : "Sending"
};

export const smsStatus = {
  Draft: "Draft",
  Sent: "Sent",
  Paused: "Paused",
  Recurring: "Recurring",
  Scheduled: "Scheduled",
  Disabled: "Disabled",
  Live: "Live",
  Completed: "Completed",
  Triggered: "Triggered",
  ListSend:"List Send",
  Sending : "Sending"
};

export const DESIGN_TYPES = {
    SMS: 'sms',
    LANDING_PAGE: 'landingPage',
    ESP: 'esp',
    TEMPLATE: 'template'
};

export const emailStatusDropdown = [
  { label: "All", value: "All" },
  { label: "Draft", value: "Draft" },
  { label: "Sent", value: "Sent" },
  { label: "Paused", value: "Paused" },
  { label: "Recurring", value: "Recurring" },
  { label: "Scheduled", value: "Scheduled" },
  { label: "Disabled", value: "Disabled" },
  { label: "Live", value: "Live" },
  { label: "Completed", value: "Completed" },
  { label: "Triggered", value: "Triggered" },
];

export const componentsClaimKey = {
  A360Plays: "A360Plays",
  AdHoc: "AdHoc",
  AudienceAIAssistance: "AudienceAIAssistance",
  AudienceSelector: "AudienceSelector",
  AvailablePlays: "AvailablePlays",
  CampaignManager: "CampaignManager",
  Contactability: "Contactability",
  CustomerLookup: "CustomerLookup",
  DatabaseOverview: "DatabaseOverview",
  DataDictionary: "DataDictionary",
  EmailSettings: "EmailSettings",
  FileManagement: "FileManagement",
  EmailManagement: "EmailManagement",
  MarketingPlayConfiguration: "MarketingPlayConfiguration",
  Forms: "Forms",
  Designs: "Designs",
  Templates: "Templates",
  StockTemplates: "StockTemplates",
  Images: "Images",
  ImageLibrary: "ImageLibrary",
  Reports: "Reports",
  Sends: "Sends",
  RFM: "RFM",
  RevenueByGeography: "RevenueByGeography",
  RevenueDetail: "RevenueDetail",
  TopA360Plays: "TopA360Plays",
  UserManagement: "UserManagement",
  TopAndBottomCustomers: "TopAndBottomCustomers",
  Demographics: "Demographics",
  Geography: "Geography",
  DataSources: "DataSources",
  DataQuality: "DataQuality",
  RevenueByChannel: "RevenueByChannel",
  Billing: "Billing",
  ListSend: "ListSend",
  SMSSettings: "SMSSettings",
  SMS: "SMS",
  SMSAdmin: "SMSAdmin",
  AbandonedCart: "AbandonedCart",
};

export const claimOperations = {
  Read: "Read",
  Update: "Update",
  Delete: "Delete",
  Create: "Create",
  Restricted: "Restricted",
  ProductRegistration: "ProductRegistration",
};

export const formStatus = {
  Draft: "Draft",
  Published: "Published",
  Deactivated: "Deactivated",
};

export const Claims = {
  Permissions: {
    ESP_Design_StartFromScratch: "ESP_Design_StartFromScratch",
  },
};

export const MarketingPlayLookup = {
  TradeIn: 1,
  PostPurchase: 2,
  CustomerWelcome: 3,
  ProspectWelcome: 4,
  Amazon: 5,
  ProductSurvey: 6,
  Replenishment: 7,
  LapsedCustomer: 8,
  LifeEventBirthday: 9,
  LifeEventAnniversary: 10,
  ProspectConversion: 11,
  CrossSell: 12,
  AbandonedCart: 13,
  HighValueCustomerAppreciation: 14,
  Segmented: 15,
};

export const BLOACK_UI_LOADER = {
  loaderType: "ball-spin-fade-loader",
  loaderColor: "#27aae1",
};

export const PerformanceType = {
  MostOpens: "MostOpens",
  MostClicks: "MostClicks",
  HighestRevenue: "HighestRevenue",
  FewestOpens: "FewestOpens",
  FewestClicks: "FewestClicks",
  LowestRevenue: "LowestRevenue",
};

export const EmailDesignerFonts = [
  {
    name: "Arial",
    fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
  },
  {
    name: "Courier",
    fontFamily:
      "'Courier New', Courier, 'Lucida Sans Typewriter', 'Lucida Typewriter', monospace",
  },
  {
    name: "Georgia",
    fontFamily: "Georgia, Times, 'Times New Roman', serif",
  },
  {
    name: "Helvetica",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  {
    name: "Lucida Sans",
    fontFamily:
      "'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Geneva, Verdana, sans-serif",
  },
  {
    name: "Tahoma",
    fontFamily: "Tahoma, Verdana, Segoe, sans-serif",
  },
  {
    name: "Times New Roman",
    fontFamily:
      "TimesNewRoman, 'Times New Roman', Times, Beskerville, Georgia, serif",
  },
  {
    name: "Trebuchet MS",
    fontFamily:
      "'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
  },
  {
    name: "Verdana",
    fontFamily: "Verdana, Geneva, sans-serif",
  },
  {
    name: "Bitter",
    fontFamily: "'Bitter', Georgia, Times, 'Times New Roman', serif",
    url: "https://fonts.googleapis.com/css?family=Bitter",
  },
  {
    name: "Droid Serif",
    fontFamily: "'Droid Serif', Georgia, Times, 'Times New Roman', serif",
    url: "https://fonts.googleapis.com/css?family=Droid+Serif",
  },
  {
    name: "Lato",
    fontFamily: "'Lato', Tahoma, Verdana, Segoe, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Lato",
  },
  {
    name: "Open Sans",
    fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Open+Sans",
  },
  {
    name: "Roboto",
    fontFamily: "'Roboto', Tahoma, Verdana, Segoe, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Roboto",
  },
  {
    name: "Source Sans Pro",
    fontFamily: "'Source Sans Pro', Tahoma, Verdana, Segoe, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Source+Sans+Pro",
  },
  {
    name: "Montserrat",
    fontFamily:
      "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Montserrat",
  },
  {
    name: "Ubuntu",
    fontFamily: "'Ubuntu', Tahoma, Verdana, Segoe, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Ubuntu",
  },
  {
    name: "Lobster",
    fontFamily: "'Lobster', Georgia, Times, serif",
    url: "https://fonts.googleapis.com/css?family=Lobster",
  },
  {
    name: "Lato",
    fontFamily: "'Lato', Tahoma, Verdana, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Lato",
  },
];

export const DEFAULT_FONTS = [
  { name: "Arial", originalName: "Arial", fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif" },
  { name: "Courier", originalName: "Courier", fontFamily: "'Courier New', Courier, 'Lucida Sans Typewriter', 'Lucida Typewriter', monospace" },
  { name: "Georgia", originalName: "Georgia", fontFamily: "Georgia, Times, 'Times New Roman', serif" },
  { name: "Helvetica Neue", originalName: "Helvetica Neue", fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif" },
  { name: "Lucida Sans", originalName: "Lucida Sans", fontFamily: "'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Geneva, Verdana, sans-serif" },
  { name: "Tahoma", originalName: "Tahoma", fontFamily: "Tahoma, Verdana, Segoe, sans-serif" },
  { name: "Times New Roman", originalName: "Times New Roman", fontFamily: "TimesNewRoman, 'Times New Roman', Times, Beskerville, Georgia, serif" },
  { name: "Trebuchet MS", originalName: "Trebuchet MS", fontFamily: "'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif" },
  { name: "Verdana", originalName: "Verdana", fontFamily: "Verdana, Geneva, sans-serif" },
  { name: "Hiragino Kaku Gothic Pro W3", originalName: "ヒラギノ角ゴ Pro W3", fontFamily: "'Hiragino Kaku Gothic Pro W3', sans-serif" },
  { name: "Meiryo", originalName: "メイリオ", fontFamily: "Meiryo, sans-serif" },
  { name: "Bitter", originalName: "Bitter", fontFamily: "'Bitter', Georgia, Times, 'Times New Roman', serif" },
  { name: "Droid Serif", originalName: "Droid Serif", fontFamily: "'Droid :Serif', Georgia, Times, 'Times New Roman', serif" },
  { name: "Lato", originalName: "Lato", fontFamily: "'Lato', Tahoma, Verdana, Segoe, sans-serif" },
  { name: "Open Sans", originalName: "Open Sans", fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif" },
  { name: "Roboto", originalName: "Roboto", fontFamily: "'Roboto', Tahoma, Verdana, Segoe, sans-serif" },
  { name: "Source Sans Pro", originalName: "Source Sans Pro", fontFamily: "'Source Sans Pro', Tahoma, Verdana, Segoe, sans-serif" },
  { name: "Montserrat", originalName: "Montserrat", fontFamily: "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif" },
  { name: "Ubuntu", originalName: "Ubuntu", fontFamily: "'Ubuntu', Tahoma, Verdana, Segoe, sans-serif" }
];

export const SYSTEM_SAFE_FONTS = [
  'Arial',
  'Courier',
  'Georgia', 
  'Helvetica Neue',
  'Lucida Sans',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'Hiragino Kaku Gothic Pro W3',
  'ヒラギノ角ゴ Pro W3',
  'Meiryo',
  'メイリオ'
];

export const WEB_FONTS_THAT_NEED_IMPORTS = [
  'Bitter',
  'Droid Serif',
  'Lato',
  'Open Sans',
  'Roboto',
  'Source Sans Pro',
  'Montserrat',
  'Ubuntu'
];

export const SERIF_INDICATORS = [
  'serif', 'georgia', 'times', 'garamond', 'baskerville', 
  'palatino', 'book', 'antiqua', 'roman', 'bodoni',
  'didot', 'cambria', 'rockwell', 'courier'
];

export const GENERIC_FAMILIES = ['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy'];

export const MonthConversion = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const BeeDefaultTemplate = {
  page: {
    title: "",
    description: "",
    template: {
      name: "template-base",
      type: "basic",
      version: "0.0.1",
    },
    body: {
      type: "mailup-bee-page-proprerties",
      container: {
        style: {
          "background-color": "#FFFFFF",
        },
      },
      content: {
        style: {
          "font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
          color: "#000000",
        },
        computedStyle: {
          linkColor: "#0068A5",
          messageBackgroundColor: "transparent",
          messageWidth: "500px",
        },
      },
    },
    rows: [
      {
        type: "one-column-empty",
        container: {
          style: {
            "background-color": "transparent",
          },
        },
        content: {
          style: {
            "background-color": "transparent",
            color: "#000000",
            width: "500px",
          },
        },
        columns: [
          {
            "grid-columns": 12,
            modules: [
              {
                type: "mailup-bee-newsletter-modules-empty",
                descriptor: {},
              },
            ],
            style: {
              "background-color": "transparent",
              "padding-top": "5px",
              "padding-right": "0px",
              "padding-bottom": "5px",
              "padding-left": "0px",
              "border-top": "0px dotted transparent",
              "border-right": "0px dotted transparent",
              "border-bottom": "0px dotted transparent",
              "border-left": "0px dotted transparent",
            },
          },
        ],
      },
    ],
  },
};

export const BeeDefaultForm = {
  page: {
    title: "Template Base",
    description: "Test template for BEE",
    template: {
      name: "template-base",
      type: "basic",
      version: "0.0.1",
    },
    body: {
      type: "mailup-bee-page-proprerties",
      container: { style: { "background-color": "#FFFFFF" } },
      content: {
        style: {
          "font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
          color: "#000000",
        },
        computedStyle: {
          linkColor: "#0068A5",
          messageBackgroundColor: "transparent",
          messageWidth: "500px",
        },
      },
      webFonts: [],
    },
    rows: [
      {
        type: "one-column-empty",
        container: {
          style: {
            "background-color": "transparent",
            "background-image": "none",
            "background-repeat": "no-repeat",
            "background-position": "top left",
          },
        },
        content: {
          style: {
            "background-color": "transparent",
            color: "#000000",
            width: "500px",
            "background-image": "none",
            "background-repeat": "no-repeat",
            "background-position": "top left",
          },
          computedStyle: {
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
          },
        },
        columns: [
          {
            "grid-columns": 12,
            modules: [
              {
                type: "mailup-bee-newsletter-modules-form",
                descriptor: {
                  form: {
                    attributes: {},
                    style: {
                      labels: {
                        color: "#000000",
                        "line-height": "200%",
                        "font-weight": "",
                        "font-style": "",
                        "text-align": "left",
                        "label-position": "top",
                      },
                      fields: {
                        color: "#000000",
                        backgroundColor: "#ffffff",
                        outlineColor: "#3AAEE0",
                        "border-top": "1px solid transparent",
                        "border-right": "1px solid transparent",
                        "border-bottom": "1px solid transparent",
                        "border-left": "1px solid transparent",
                        "padding-top": "5px",
                        "padding-right": "5px",
                        "padding-bottom": "5px",
                        "padding-left": "5px",
                        "border-radius": "4px",
                      },
                      buttons: {
                        backgroundColor: "#3AAEE0",
                        "border-radius": "4px",
                        "border-top": "0px solid transparent",
                        "border-right": "0px solid transparent",
                        "border-bottom": "0px solid transparent",
                        "border-left": "0px solid transparent",
                        color: "#ffffff",
                        "line-height": "200%",
                        "text-align": "center",
                        width: "100%",
                        "max-width": "100%",
                        "padding-top": "5px",
                        "padding-right": "20px",
                        "padding-bottom": "5px",
                        "padding-left": "20px",
                        outer: {
                          flexGrow: 1,
                          display: "block",
                          "padding-top": "0px",
                          "padding-right": "0px",
                          "padding-bottom": "0px",
                          "padding-left": "0px",
                        },
                      },
                    },
                  },
                  style: {
                    width: "100%",
                    "font-size": "14px",
                    "text-align": "center",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    "padding-bottom": "10px",
                    "padding-left": "10px",
                    "font-family": "inherit",
                    "background-color": "transparent",
                  },
                  computedStyle: {
                    class: "center",
                    hideContentOnMobile: false,
                    hideContentOnDesktop: false,
                  },
                },
                uuid: "7c4948ac-1b8d-498f-9668-cb3f03ac642f",
              },
            ],
            style: {
              "background-color": "transparent",
              "padding-top": "5px",
              "padding-right": "0px",
              "padding-bottom": "5px",
              "padding-left": "0px",
              "border-top": "0px solid transparent",
              "border-right": "0px solid transparent",
              "border-bottom": "0px solid transparent",
              "border-left": "0px solid transparent",
            },
            uuid: "90ca9408-e7be-4f7f-a3c7-7c644395ce27",
          },
        ],
        uuid: "b0394ab1-23f8-45e8-b893-189ecfe57bdf",
      },
    ],
  },
  comments: {},
};

export const BeeDefaultConfig = {
  container: "bee-plugin-container",
  language: "en-US",
  labels: {
    mergeTags: "Merge tags",
    rowDisplayConditions: "Manage Display Condition",
    manageForm: "Advanced Field Properties",
  },
};

export const  UTMPARAMSLIST=[
  { label: "utm_source", value: 1 ,TrackingParameterValue:""},
  { label: "utm_medium", value: 2,TrackingParameterValue:"" },
  { label: "utm_campaign", value: 3,TrackingParameterValue:""},
  { label: "utm_term", value: 4,TrackingParameterValue:"" },
  { label: "utm_content", value: 5,TrackingParameterValue:""},
]

export const STEP_WIZARD = {
  Campaign: 1,
  Audience: 2,
  Design: 3,
  Summary: 4,
  Send: 5
};

export const AUDIENCE_TYPE = {
  Audience : "Audience",
  ComplexAudience : "ComplexAudience"
};

export const LocalStorageKeys = {
  isLeftMenuOpened: "isLeftMenuOpened"
};

export const MANAGE_COLUMN_ENTITIES = {
  ManageCampaigns: "ManageCampaigns",
  ESPDesignLibrary: "ESPDesignLibrary",
  LandingPageDesignLibrary : "LandingPageDesignLibrary",
  SMSDesignLibrary: "SMSDesignLibrary",
  FormSubmission: "FormSubmission",
  SMSSubscriberReport: "SMSSubscriberReport",
  ESPSubscriberReport: "ESPSubscriberReport",
  DataDictionary: "DataDictionary",
  PreferenceCenter: "PreferenceCenter",
  CustomerLookup: {
    CustomerLookup: "CustomerLookup",
    CustomerWebHistory: "CustomerWebHistory",
    CustomerEmailHistory: "CustomerEmailHistory",
    CustomerTransactionHistory: "CustomerTransactionHistory",
    CustomerReservationHistory: "CustomerReservationHistory",
    CustomerProductDetailReg: "CustomerProductDetailReg"
  }
}

export const SAVED_ROWS_CATEGORIES = {
  UnsubscribedForm: 9,
  AllSavedRows: -1
}

export const TemplateType = {
  Template: "Template",
  Design: "Design"
}

export const TargetActionType = {
  Create: 0,
  Append: 1,
  Overwrite: 2,
  Other: 3,
  FileExport: 4,
  RetrieveData: 5
}

export const ProductTypes = {
  FreeTrial : 1,
  Flash360 : 2,
  Professional : 3,
  Enterprise : 4,
  Flash360Basic : 5,
  Flash360Core : 6,
  Internal: 7
}

export const LandingPageTypes = {
  PreferenceCenter : 10
}

export const SubjectLineMaxLength = {
  Length : 128
}

export const FromNameMaxLength = {
  Length : 50
}

export const PreHeaderMaxLength = {
  Length : 512
}

export const DEFAULT_SHORT_URL = import.meta.env.VITE_DEFAULT_SHORT_URL;

export { validateFolderName, VALIDATION_PRESETS };

export const BackgroundProcessingStatus = [
  { value: "", label: "All" },
  { value: "Initiated", label: "Initiated" },
  { value: "WaitingForExecute", label: "WaitingForExecute" },
  { value: "Started", label: "Started" },
  { value: "RetrievingContacts", label: "RetrievingContacts" },
  { value: "Processing", label: "Processing" },
  { value: "Finished", label: "Finished" },
  { value: "Failed", label: "Failed" },
  { value: "Canceling", label: "Canceling" },
  { value: "Canceled", label: "Canceled" }
];


export const smartEncodingMapping = [
    {
        Unicode: "U+FF10",
        Glyph: "０",
        Description: "Fullwidth Digit Zero",
        TransliteratedCharacter: "0"
    },
    {
        Unicode: "U+FF11",
        Glyph: "１",
        Description: "Fullwidth Digit One",
        TransliteratedCharacter: "1"
    },
    {
        Unicode: "U+FF12",
        Glyph: "２",
        Description: "Fullwidth Digit Two",
        TransliteratedCharacter: "2"
    },
    {
        Unicode: "U+FF13",
        Glyph: "３",
        Description: "Fullwidth Digit Three",
        TransliteratedCharacter: "3"
    },
    {
        Unicode: "U+FF14",
        Glyph: "４",
        Description: "Fullwidth Digit Four",
        TransliteratedCharacter: "4"
    },
    {
        Unicode: "U+FF15",
        Glyph: "５",
        Description: "Fullwidth Digit Five",
        TransliteratedCharacter: "5"
    },
    {
        Unicode: "U+FF16",
        Glyph: "６",
        Description: "Fullwidth Digit Six",
        TransliteratedCharacter: "6"
    },
    {
        Unicode: "U+FF17",
        Glyph: "７",
        Description: "Fullwidth Digit Seven",
        TransliteratedCharacter: "7"
    },
    {
        Unicode: "U+FF18",
        Glyph: "８",
        Description: "Fullwidth Digit Eight",
        TransliteratedCharacter: "8"
    },
    {
        Unicode: "U+FF19",
        Glyph: "９",
        Description: "Fullwidth Digit Nine",
        TransliteratedCharacter: "9"
    },
    {
        Unicode: "U+00BD",
        Glyph: "½",
        Description: "Vulgar Fraction One Half",
        TransliteratedCharacter: "1/2"
    },
    {
        Unicode: "U+2153",
        Glyph: "⅓",
        Description: "Vulgar Fraction One Third",
        TransliteratedCharacter: "1/3"
    },
    {
        Unicode: "U+00BC",
        Glyph: "¼",
        Description: "Vulgar Fraction One Quarter",
        TransliteratedCharacter: "1/4"
    },
    {
        Unicode: "U+2155",
        Glyph: "⅕",
        Description: "Vulgar Fraction One Fifth",
        TransliteratedCharacter: "1/5"
    },
    {
        Unicode: "U+2152",
        Glyph: "⅒",
        Description: "Vulgar Fraction One Tenth",
        TransliteratedCharacter: "1/10"
    },
    {
        Unicode: "U+2154",
        Glyph: "⅔",
        Description: "Vulgar Fraction Two Thirds",
        TransliteratedCharacter: "2/3"
    },
    {
        Unicode: "U+2156",
        Glyph: "⅖",
        Description: "Vulgar Fraction Two Fifths",
        TransliteratedCharacter: "2/5"
    },
    {
        Unicode: "U+00BE",
        Glyph: "¾",
        Description: "Vulgar Fraction Three Quarters",
        TransliteratedCharacter: "3/4"
    },
    {
        Unicode: "U+2157",
        Glyph: "⅗",
        Description: "Vulgar Fraction Three Fifths",
        TransliteratedCharacter: "3/5"
    },
    {
        Unicode: "U+2158",
        Glyph: "⅘",
        Description: "Vulgar Fraction Four Fifths",
        TransliteratedCharacter: "4/5"
    },
    {
        Unicode: "U+00B4",
        Glyph: "´",
        Description: "Acute Accent",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+0313",
        Glyph: "̓",
        Description: "Combining Comma Above",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+0314",
        Glyph: "̓̔",
        Description: "Combining Reversed Comma Above",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+FF07",
        Glyph: "＇",
        Description: "Fullwidth Apostrophe",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+0060",
        Glyph: "`",
        Description: "Grave Accent",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+275C",
        Glyph: "❜",
        Description: "Heavy Single Comma Quotation Mark Ornament",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+275B",
        Glyph: "❛",
        Description: "Heavy Single Turned Comma Quotation Mark Ornament",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+2018",
        Glyph: "'",
        Description: "Left Single Quotation Mark",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02CA",
        Glyph: "ˊ",
        Description: "Modifier Letter Acute Accent",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02BC",
        Glyph: "ʼ",
        Description: "Modifier Letter Apostrophe",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02CB",
        Glyph: "ˋ",
        Description: "Modifier Letter Grave Accent",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02B9",
        Glyph: "ʹ",
        Description: "Modifier Letter Prime",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02BD",
        Glyph: "ʽ",
        Description: "Modifier Letter Reversed Comma",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02BB",
        Glyph: "ʻ",
        Description: "Modifier Letter Turned Comma",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+02C8",
        Glyph: "ˈ",
        Description: "Modifier Letter Vertical Line",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+00A0",
        Glyph: " ",
        Description: "No-Break Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+FE10",
        Glyph: "︐",
        Description: "Presentation Form For Vertical Comma",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+FE11",
        Glyph: "︑",
        Description: "Presentation Form For Vertical Ideographic Comma",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+2019",
        Glyph: "'",
        Description: "Right Single Quotation Mark",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+201B",
        Glyph: "‛",
        Description: "Single High-Reversed-9 Quotation Mark",
        TransliteratedCharacter: "'"
    },
    {
        Unicode: "U+2000",
        Glyph: " ",
        Description: "Whitespace: En Quad",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2022",
        Glyph: "•",
        Description: "Bullet",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+2014",
        Glyph: "—",
        Description: "Em Dash",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+2013",
        Glyph: "-",
        Description: "En Dash",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+FF0D",
        Glyph: "－",
        Description: "Fullwidth Hyphen-Minus",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+2015",
        Glyph: "―",
        Description: "Horizontal Bar",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+23BC",
        Glyph: "⎼",
        Description: "Horizontal Scan Line-7",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+23BD",
        Glyph: "⎽",
        Description: "Horizontal Scan Line-9",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+2010",
        Glyph: "‐",
        Description: "Hyphen",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+2043",
        Glyph: "⁃",
        Description: "Hyphen Bullet",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+FE63",
        Glyph: "﹣",
        Description: "Small Hyphen-Minus",
        TransliteratedCharacter: "-"
    },
    {
        Unicode: "U+FF01",
        Glyph: "！",
        Description: "Fullwidth Exclamation Mark",
        TransliteratedCharacter: "!"
    },
    {
        Unicode: "U+01C3",
        Glyph: "ǃ",
        Description: "Latin Letter Retroflex Click",
        TransliteratedCharacter: "!"
    },
    {
        Unicode: "U+FE15",
        Glyph: "︕",
        Description: "Presentation Form For Vertical Exclamation Mark",
        TransliteratedCharacter: "!"
    },
    {
        Unicode: "U+FE57",
        Glyph: "﹗",
        Description: "Small Exclamation Mark",
        TransliteratedCharacter: "!"
    },
    {
        Unicode: "U+203C",
        Glyph: "‼",
        Description: "Double Exclamation Mark",
        TransliteratedCharacter: "!!"
    },
    {
        Unicode: "U+2260",
        Glyph: "≠",
        Description: "Not Equal To",
        TransliteratedCharacter: "!="
    },
    {
        Unicode: "U+201F",
        Glyph: "‟",
        Description: "Double High-Reversed-9 Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+201E",
        Glyph: "„",
        Description: "Double Low Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+301E",
        Glyph: "〞",
        Description: "Double Prime Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+FF02",
        Glyph: "＂",
        Description: "Fullwidth Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+275E",
        Glyph: "❞",
        Description: "Heavy Double Comma Quotation Mark Ornament",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+275D",
        Glyph: "❝",
        Description: "Heavy Double Turned Comma Quotation Mark Ornament",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+201C",
        Glyph: "\"",
        Description: "Left Double Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+00AB",
        Glyph: "«",
        Description: "Left-Pointing Double Angle Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+02EE",
        Glyph: "ˮ",
        Description: "Modifier Letter Double Apostrophe",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+02BA",
        Glyph: "ʺ",
        Description: "Modifier Letter Double Prime",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+301D",
        Glyph: "〝",
        Description: "Reversed Double Prime Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+201D",
        Glyph: "\"",
        Description: "Right Double Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+00BB",
        Glyph: "»",
        Description: "Right-Pointing Double Angle Quotation Mark",
        TransliteratedCharacter: "\""
    },
    {
        Unicode: "U+FF03",
        Glyph: "＃",
        Description: "Fullwidth Number Sign",
        TransliteratedCharacter: "#"
    },
    {
        Unicode: "U+FE5F",
        Glyph: "﹟",
        Description: "Small Number Sign",
        TransliteratedCharacter: "#"
    },
    {
        Unicode: "U+FF04",
        Glyph: "＄",
        Description: "Fullwidth Dollar Sign",
        TransliteratedCharacter: "$"
    },
    {
        Unicode: "U+FE69",
        Glyph: "﹩",
        Description: "Small Dollar Sign",
        TransliteratedCharacter: "$"
    },
    {
        Unicode: "U+FF05",
        Glyph: "％",
        Description: "Fullwidth Percent Sign",
        TransliteratedCharacter: "%"
    },
    {
        Unicode: "U+FE6A",
        Glyph: "﹪",
        Description: "Small Percent Sign",
        TransliteratedCharacter: "%"
    },
    {
        Unicode: "U+FF06",
        Glyph: "＆",
        Description: "Fullwidth Ampersand",
        TransliteratedCharacter: "&"
    },
    {
        Unicode: "U+FE60",
        Glyph: "﹠",
        Description: "Small Ampersand",
        TransliteratedCharacter: "&"
    },
    {
        Unicode: "U+FF08",
        Glyph: "（",
        Description: "Fullwidth Left Parenthesis",
        TransliteratedCharacter: "("
    },
    {
        Unicode: "U+2985",
        Glyph: "⦅",
        Description: "Left White Parenthesis",
        TransliteratedCharacter: "("
    },
    {
        Unicode: "U+27EE",
        Glyph: "⟮",
        Description: "Mathematical Left Flattened Parenthesis",
        TransliteratedCharacter: "("
    },
    {
        Unicode: "U+276A",
        Glyph: "❪",
        Description: "Medium Flattened Left Parenthesis Ornament",
        TransliteratedCharacter: "("
    },
    {
        Unicode: "U+2768",
        Glyph: "❨",
        Description: "Medium Left Parenthesis Ornament",
        TransliteratedCharacter: "("
    },
    {
        Unicode: "U+FE59",
        Glyph: "﹙",
        Description: "Small Left Parenthesis",
        TransliteratedCharacter: "("
    },
    {
        Unicode: "U+FF09",
        Glyph: "）",
        Description: "Fullwidth Right Parenthesis",
        TransliteratedCharacter: ")"
    },
    {
        Unicode: "U+27EF",
        Glyph: "⟯",
        Description: "Mathematical Right Flattened Parenthesis",
        TransliteratedCharacter: ")"
    },
    {
        Unicode: "U+276B",
        Glyph: "❫",
        Description: "Medium Flattened Right Parenthesis Ornament",
        TransliteratedCharacter: ")"
    },
    {
        Unicode: "U+2769",
        Glyph: "❩",
        Description: "Medium Right Parenthesis Ornament",
        TransliteratedCharacter: ")"
    },
    {
        Unicode: "U+2986",
        Glyph: "⦆",
        Description: "Right White Parenthesis",
        TransliteratedCharacter: ")"
    },
    {
        Unicode: "U+FE5A",
        Glyph: "﹚",
        Description: "Small Right Parenthesis",
        TransliteratedCharacter: ")"
    },
    {
        Unicode: "U+2217",
        Glyph: "∗",
        Description: "Asterisk Operator",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2749",
        Glyph: "❉",
        Description: "Balloon-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+229B",
        Glyph: "⊛",
        Description: "Circled Asterisk Operator",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2733",
        Glyph: "✳",
        Description: "Eight Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+274A",
        Glyph: "❊",
        Description: "Eight Teardrop-Spoked Propeller Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2723",
        Glyph: "✣",
        Description: "Four Balloon-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2725",
        Glyph: "✥",
        Description: "Four Club-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2722",
        Glyph: "✢",
        Description: "Four Teardrop-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+FF0A",
        Glyph: "＊",
        Description: "Fullwidth Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2731",
        Glyph: "✱",
        Description: "Heavy Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+274B",
        Glyph: "❋",
        Description: "Heavy Eight Teardrop-Spoked Propeller Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2724",
        Glyph: "✤",
        Description: "Heavy Four Balloon-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+273D",
        Glyph: "✽",
        Description: "Heavy Teardrop-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2743",
        Glyph: "❃",
        Description: "Heavy Teardrop-Spoked Pinwheel Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+204E",
        Glyph: "⁎",
        Description: "Low Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+2732",
        Glyph: "✲",
        Description: "Open Center Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+273C",
        Glyph: "✼",
        Description: "Open Center Teardrop-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+273A",
        Glyph: "✺",
        Description: "Sixteen Pointed Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+FE61",
        Glyph: "﹡",
        Description: "Small Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+29C6",
        Glyph: "⧆",
        Description: "Squared Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+273B",
        Glyph: "✻",
        Description: "Teardrop-Spoked Asterisk",
        TransliteratedCharacter: "*"
    },
    {
        Unicode: "U+0326",
        Glyph: "̦",
        Description: "Combining Comma Below",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+FF0C",
        Glyph: "，",
        Description: "Fullwidth Comma",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+FF64",
        Glyph: "､",
        Description: "Halfwidth Ideographic Comma",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+3001",
        Glyph: "、",
        Description: "Ideographic Comma",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+201A",
        Glyph: "‚",
        Description: "Single Low-9 Quotation Mark",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+FE50",
        Glyph: "﹐",
        Description: "Small Comma",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+FE51",
        Glyph: "﹑",
        Description: "Small Ideographic Comma",
        TransliteratedCharacter: ","
    },
    {
        Unicode: "U+FF0E",
        Glyph: "．",
        Description: "Fullwidth Full Stop",
        TransliteratedCharacter: "."
    },
    {
        Unicode: "U+FF61",
        Glyph: "｡",
        Description: "Halfwidth Ideographic Full Stop",
        TransliteratedCharacter: "."
    },
    {
        Unicode: "U+3002",
        Glyph: "。",
        Description: "Ideographic Full Stop",
        TransliteratedCharacter: "."
    },
    {
        Unicode: "U+FE52",
        Glyph: "﹒",
        Description: "Small Full Stop",
        TransliteratedCharacter: "."
    },
    {
        Unicode: "U+2026",
        Glyph: "…",
        Description: "Horizontal Ellipsis",
        TransliteratedCharacter: "..."
    },
    {
        Unicode: "U+22EF",
        Glyph: "⋯",
        Description: "Midline Horizontal Ellipsis",
        TransliteratedCharacter: "..."
    },
    {
        Unicode: "U+29F8",
        Glyph: "⧸",
        Description: "Big Solidus",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+0338",
        Glyph: "̸̸",
        Description: "Combining Long Solidus Overlay",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+0337",
        Glyph: "̷̷",
        Description: "Combining Short Solidus Overlay",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+00F7",
        Glyph: "÷",
        Description: "Division Sign",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+2215",
        Glyph: "∕",
        Description: "Division Slash",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+2044",
        Glyph: "⁄",
        Description: "Fraction Slash",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+FF0F",
        Glyph: "／",
        Description: "Fullwidth Solidus",
        TransliteratedCharacter: "/"
    },
    {
        Unicode: "U+FF1A",
        Glyph: "：",
        Description: "Fullwidth Colon",
        TransliteratedCharacter: ":"
    },
    {
        Unicode: "U+A789",
        Glyph: "꞉",
        Description: "Modifier Letter Colon",
        TransliteratedCharacter: ":"
    },
    {
        Unicode: "U+02F8",
        Glyph: "˸",
        Description: "Modifier Letter Raised Colon",
        TransliteratedCharacter: ":"
    },
    {
        Unicode: "U+02D0",
        Glyph: "ː",
        Description: "Modifier Letter Triangular Colon",
        TransliteratedCharacter: ":"
    },
    {
        Unicode: "U+FE13",
        Glyph: "︓",
        Description: "Presentation Form For Vertical Colon",
        TransliteratedCharacter: ":"
    },
    {
        Unicode: "U+2982",
        Glyph: "⦂",
        Description: "Z Notation Type Colon",
        TransliteratedCharacter: ":"
    },
    {
        Unicode: "U+FF1B",
        Glyph: "；",
        Description: "Fullwidth Semicolon",
        TransliteratedCharacter: ";"
    },
    {
        Unicode: "U+FE14",
        Glyph: "︔",
        Description: "Presentation Form For Vertical Semicolon",
        TransliteratedCharacter: ";"
    },
    {
        Unicode: "U+204F",
        Glyph: "⁏",
        Description: "Reversed Semicolon",
        TransliteratedCharacter: ";"
    },
    {
        Unicode: "U+FE54",
        Glyph: "﹔",
        Description: "Small Semicolon",
        TransliteratedCharacter: ";"
    },
    {
        Unicode: "U+FF1F",
        Glyph: "？",
        Description: "Fullwidth Question Mark",
        TransliteratedCharacter: "?"
    },
    {
        Unicode: "U+FE16",
        Glyph: "︖",
        Description: "Presentation Form For Vertical Question Mark",
        TransliteratedCharacter: "?"
    },
    {
        Unicode: "U+FE56",
        Glyph: "﹖",
        Description: "Small Question Mark",
        TransliteratedCharacter: "?"
    },
    {
        Unicode: "U+2048",
        Glyph: "⁈",
        Description: "Question Exclamation Mark",
        TransliteratedCharacter: "?!"
    },
    {
        Unicode: "U+2047",
        Glyph: "⁇",
        Description: "Double Question Mark",
        TransliteratedCharacter: "??"
    },
    {
        Unicode: "U+FF20",
        Glyph: "＠",
        Description: "Fullwidth Commercial At Sign",
        TransliteratedCharacter: "@"
    },
    {
        Unicode: "U+FE6B",
        Glyph: "﹫",
        Description: "Small Commercial At Sign",
        TransliteratedCharacter: "@"
    },
    {
        Unicode: "U+FF3B",
        Glyph: "［",
        Description: "Fullwidth Left Square Bracket",
        TransliteratedCharacter: "["
    },
    {
        Unicode: "U+29F9",
        Glyph: "⧹",
        Description: "Big Reverse Solidus",
        TransliteratedCharacter: "\\"
    },
    {
        Unicode: "U+20E5",
        Glyph: "?",
        Description: "Combining Reverse Solidus Overlay",
        TransliteratedCharacter: "\\"
    },
    {
        Unicode: "U+FF3C",
        Glyph: "＼",
        Description: "Fullwidth Reverse Solidus",
        TransliteratedCharacter: "\\"
    },
    {
        Unicode: "U+29F5",
        Glyph: "⧵",
        Description: "Reverse Solidus Operator",
        TransliteratedCharacter: "\\"
    },
    {
        Unicode: "U+FE68",
        Glyph: "﹨",
        Description: "Small Reverse Solidus",
        TransliteratedCharacter: "\\"
    },
    {
        Unicode: "U+FF3D",
        Glyph: "］",
        Description: "Fullwidth Right Square Bracket",
        TransliteratedCharacter: "]"
    },
    {
        Unicode: "U+0302",
        Glyph: "̂̂",
        Description: "Combining Circumflex Accent",
        TransliteratedCharacter: "^"
    },
    {
        Unicode: "U+1DCD",
        Glyph: "᷍",
        Description: "Combining Double Circumflex Above",
        TransliteratedCharacter: "^"
    },
    {
        Unicode: "U+FF3E",
        Glyph: "＾",
        Description: "Fullwidth Circumflex Accent",
        TransliteratedCharacter: "^"
    },
    {
        Unicode: "U+02C6",
        Glyph: "ˆ",
        Description: "Modifier Letter Circumflex Accent",
        TransliteratedCharacter: "^"
    },
    {
        Unicode: "U+0332",
        Glyph: "̲",
        Description: "Combining Low Line",
        TransliteratedCharacter: "_"
    },
    {
        Unicode: "U+2017",
        Glyph: "‗",
        Description: "Double Low Line",
        TransliteratedCharacter: "_"
    },
    {
        Unicode: "U+FF3F",
        Glyph: "＿",
        Description: "Fullwidth Low Line",
        TransliteratedCharacter: "_"
    },
    {
        Unicode: "U+FF5B",
        Glyph: "｛",
        Description: "Fullwidth Left Curly Bracket",
        TransliteratedCharacter: "{"
    },
    {
        Unicode: "U+2774",
        Glyph: "❴",
        Description: "Medium Left Curly Bracket Ornament",
        TransliteratedCharacter: "{"
    },
    {
        Unicode: "U+FE5B",
        Glyph: "﹛",
        Description: "Small Left Curly Bracket",
        TransliteratedCharacter: "{"
    },
    {
        Unicode: "U+20D2",
        Glyph: "⃒",
        Description: "Combining Long Vertical Line Overlay",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+20D3",
        Glyph: "⃓",
        Description: "Combining Short Vertical Line Overlay",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+2223",
        Glyph: "∣",
        Description: "Divides",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+FF5C",
        Glyph: "｜",
        Description: "Fullwidth Vertical Line",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+239C",
        Glyph: "⎜",
        Description: "Left Parenthesis Extension",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+23B8",
        Glyph: "⎸",
        Description: "Left Vertical Box Line",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+239F",
        Glyph: "⎟",
        Description: "Right Parenthesis Extension",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+23B9",
        Glyph: "⎹",
        Description: "Right Vertical Box Line",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+23D0",
        Glyph: "⏐",
        Description: "Vertical Line Extension",
        TransliteratedCharacter: "|"
    },
    {
        Unicode: "U+FF5D",
        Glyph: "｝",
        Description: "Fullwidth Right Curly Bracket",
        TransliteratedCharacter: "}"
    },
    {
        Unicode: "U+2775",
        Glyph: "❵",
        Description: "Medium Right Curly Bracket Ornament",
        TransliteratedCharacter: "}"
    },
    {
        Unicode: "U+FE5C",
        Glyph: "﹜",
        Description: "Small Right Curly Bracket",
        TransliteratedCharacter: "}"
    },
    {
        Unicode: "U+0303",
        Glyph: "̃̃",
        Description: "Combining Tilde",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+0330",
        Glyph: "̰̰̰̰",
        Description: "Combining Tilde Below",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+0334",
        Glyph: "̴̴",
        Description: "Combining Tilde Overlay",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+FF5E",
        Glyph: "～",
        Description: "Fullwidth Tilde",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+02F7",
        Glyph: "˷",
        Description: "Modifier Letter Low Tilde",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+02DC",
        Glyph: "˜",
        Description: "Small Tilde",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+223C",
        Glyph: "∼",
        Description: "Tilde Operator",
        TransliteratedCharacter: "~"
    },
    {
        Unicode: "U+FF0B",
        Glyph: "＋",
        Description: "Fullwidth Plus Sign",
        TransliteratedCharacter: "+"
    },
    {
        Unicode: "U+02D6",
        Glyph: "˖",
        Description: "Modifier Letter Plus Sign",
        TransliteratedCharacter: "+"
    },
    {
        Unicode: "U+FE62",
        Glyph: "﹢",
        Description: "Small Plus Sign",
        TransliteratedCharacter: "+"
    },
    {
        Unicode: "U+FF1C",
        Glyph: "＜",
        Description: "Fullwidth Less-Than Sign",
        TransliteratedCharacter: "<"
    },
    {
        Unicode: "U+203A",
        Glyph: "›",
        Description: "Single Right-Pointing Angle Quotation Mark",
        TransliteratedCharacter: "<"
    },
    {
        Unicode: "U+FE64",
        Glyph: "﹤",
        Description: "Small Less-Than Sign",
        TransliteratedCharacter: "<"
    },
    {
        Unicode: "U+226A",
        Glyph: "≪",
        Description: "Much Less-Than",
        TransliteratedCharacter: "<<"
    },
    {
        Unicode: "U+0347",
        Glyph: "͇",
        Description: "Combining Equals Sign Below",
        TransliteratedCharacter: "="
    },
    {
        Unicode: "U+FF1D",
        Glyph: "＝",
        Description: "Fullwidth Equals Sign",
        TransliteratedCharacter: "="
    },
    {
        Unicode: "U+A78A",
        Glyph: "꞊",
        Description: "Modifier Letter Short Equals Sign",
        TransliteratedCharacter: "="
    },
    {
        Unicode: "U+FE66",
        Glyph: "﹦",
        Description: "Small Equals Sign",
        TransliteratedCharacter: "="
    },
    {
        Unicode: "U+FF1E",
        Glyph: "＞",
        Description: "Fullwidth Greater-Than Sign",
        TransliteratedCharacter: ">"
    },
    {
        Unicode: "U+2039",
        Glyph: "‹",
        Description: "Single Left-Pointing Angle Quotation Mark",
        TransliteratedCharacter: ">"
    },
    {
        Unicode: "U+FE65",
        Glyph: "﹥",
        Description: "Small Greater-Than Sign",
        TransliteratedCharacter: ">"
    },
    {
        Unicode: "U+226B",
        Glyph: "≫",
        Description: "Much Greater-Than",
        TransliteratedCharacter: ">>"
    },
    {
        Unicode: "U+FF21",
        Glyph: "Ａ",
        Description: "Fullwidth Latin Capital Letter A",
        TransliteratedCharacter: "A"
    },
    {
        Unicode: "U+1D00",
        Glyph: "ᴀ",
        Description: "Latin Letter Small Capital A",
        TransliteratedCharacter: "A"
    },
    {
        Unicode: "U+FF22",
        Glyph: "Ｂ",
        Description: "Fullwidth Latin Capital Letter B",
        TransliteratedCharacter: "B"
    },
    {
        Unicode: "U+0299",
        Glyph: "ʙ",
        Description: "Latin Letter Small Capital B",
        TransliteratedCharacter: "B"
    },
    {
        Unicode: "U+FF23",
        Glyph: "Ｃ",
        Description: "Fullwidth Latin Capital Letter C",
        TransliteratedCharacter: "C"
    },
    {
        Unicode: "U+1D04",
        Glyph: "ᴄ",
        Description: "Latin Letter Small Capital C",
        TransliteratedCharacter: "C"
    },
    {
        Unicode: "U+FF24",
        Glyph: "Ｄ",
        Description: "Fullwidth Latin Capital Letter D",
        TransliteratedCharacter: "D"
    },
    {
        Unicode: "U+1D05",
        Glyph: "ᴅ",
        Description: "Latin Letter Small Capital D",
        TransliteratedCharacter: "D"
    },
    {
        Unicode: "U+FF25",
        Glyph: "Ｅ",
        Description: "Fullwidth Latin Capital Letter E",
        TransliteratedCharacter: "E"
    },
    {
        Unicode: "U+1D07",
        Glyph: "ᴇ",
        Description: "Latin Letter Small Capital E",
        TransliteratedCharacter: "E"
    },
    {
        Unicode: "U+FF26",
        Glyph: "Ｆ",
        Description: "Fullwidth Latin Capital Letter F",
        TransliteratedCharacter: "F"
    },
    {
        Unicode: "U+A730",
        Glyph: "ꜰ",
        Description: "Latin Letter Small Capital F",
        TransliteratedCharacter: "F"
    },
    {
        Unicode: "U+FF27",
        Glyph: "Ｇ",
        Description: "Fullwidth Latin Capital Letter G",
        TransliteratedCharacter: "G"
    },
    {
        Unicode: "U+0262",
        Glyph: "ɢ",
        Description: "Latin Letter Small Capital G",
        TransliteratedCharacter: "G"
    },
    {
        Unicode: "U+FF28",
        Glyph: "Ｈ",
        Description: "Fullwidth Latin Capital Letter H",
        TransliteratedCharacter: "H"
    },
    {
        Unicode: "U+029C",
        Glyph: "ʜ",
        Description: "Latin Letter Small Capital H",
        TransliteratedCharacter: "H"
    },
    {
        Unicode: "U+FF29",
        Glyph: "Ｉ",
        Description: "Fullwidth Latin Capital Letter I",
        TransliteratedCharacter: "I"
    },
    {
        Unicode: "U+026A",
        Glyph: "ɪ",
        Description: "Latin Letter Small Capital I",
        TransliteratedCharacter: "I"
    },
    {
        Unicode: "U+FF2A",
        Glyph: "Ｊ",
        Description: "Fullwidth Latin Capital Letter J",
        TransliteratedCharacter: "J"
    },
    {
        Unicode: "U+1D0A",
        Glyph: "ᴊ",
        Description: "Latin Letter Small Capital J",
        TransliteratedCharacter: "J"
    },
    {
        Unicode: "U+FF2B",
        Glyph: "Ｋ",
        Description: "Fullwidth Latin Capital Letter K",
        TransliteratedCharacter: "K"
    },
    {
        Unicode: "U+1D0B",
        Glyph: "ᴋ",
        Description: "Latin Letter Small Capital K",
        TransliteratedCharacter: "K"
    },
    {
        Unicode: "U+FF2C",
        Glyph: "Ｌ",
        Description: "Fullwidth Latin Capital Letter L",
        TransliteratedCharacter: "L"
    },
    {
        Unicode: "U+029F",
        Glyph: "ʟ",
        Description: "Latin Letter Small Capital L",
        TransliteratedCharacter: "L"
    },
    {
        Unicode: "U+FF2D",
        Glyph: "Ｍ",
        Description: "Fullwidth Latin Capital Letter M",
        TransliteratedCharacter: "M"
    },
    {
        Unicode: "U+1D0D",
        Glyph: "ᴍ",
        Description: "Latin Letter Small Capital M",
        TransliteratedCharacter: "M"
    },
    {
        Unicode: "U+FF2E",
        Glyph: "Ｎ",
        Description: "Fullwidth Latin Capital Letter N",
        TransliteratedCharacter: "N"
    },
    {
        Unicode: "U+0274",
        Glyph: "ɴ",
        Description: "Latin Letter Small Capital N",
        TransliteratedCharacter: "N"
    },
    {
        Unicode: "U+FF2F",
        Glyph: "Ｏ",
        Description: "Fullwidth Latin Capital Letter O",
        TransliteratedCharacter: "O"
    },
    {
        Unicode: "U+1D0F",
        Glyph: "ᴏ",
        Description: "Latin Letter Small Capital O",
        TransliteratedCharacter: "O"
    },
    {
        Unicode: "U+FF30",
        Glyph: "Ｐ",
        Description: "Fullwidth Latin Capital Letter P",
        TransliteratedCharacter: "P"
    },
    {
        Unicode: "U+1D18",
        Glyph: "ᴘ",
        Description: "Latin Letter Small Capital P",
        TransliteratedCharacter: "P"
    },
    {
        Unicode: "U+FF31",
        Glyph: "Ｑ",
        Description: "Fullwidth Latin Capital Letter Q",
        TransliteratedCharacter: "Q"
    },
    {
        Unicode: "U+FF32",
        Glyph: "Ｒ",
        Description: "Fullwidth Latin Capital Letter R",
        TransliteratedCharacter: "R"
    },
    {
        Unicode: "U+0280",
        Glyph: "ʀ",
        Description: "Latin Letter Small Capital R",
        TransliteratedCharacter: "R"
    },
    {
        Unicode: "U+FF33",
        Glyph: "Ｓ",
        Description: "Fullwidth Latin Capital Letter S",
        TransliteratedCharacter: "S"
    },
    {
        Unicode: "U+A731",
        Glyph: "ꜱ",
        Description: "Latin Letter Small Capital S",
        TransliteratedCharacter: "S"
    },
    {
        Unicode: "U+FF34",
        Glyph: "Ｔ",
        Description: "Fullwidth Latin Capital Letter T",
        TransliteratedCharacter: "T"
    },
    {
        Unicode: "U+1D1B",
        Glyph: "ᴛ",
        Description: "Latin Letter Small Capital T",
        TransliteratedCharacter: "T"
    },
    {
        Unicode: "U+FF35",
        Glyph: "Ｕ",
        Description: "Fullwidth Latin Capital Letter U",
        TransliteratedCharacter: "U"
    },
    {
        Unicode: "U+1D1C",
        Glyph: "ᴜ",
        Description: "Latin Letter Small Capital U",
        TransliteratedCharacter: "U"
    },
    {
        Unicode: "U+FF36",
        Glyph: "Ｖ",
        Description: "Fullwidth Latin Capital Letter V",
        TransliteratedCharacter: "V"
    },
    {
        Unicode: "U+1D20",
        Glyph: "ᴠ",
        Description: "Latin Letter Small Capital V",
        TransliteratedCharacter: "V"
    },
    {
        Unicode: "U+FF37",
        Glyph: "Ｗ",
        Description: "Fullwidth Latin Capital Letter W",
        TransliteratedCharacter: "W"
    },
    {
        Unicode: "U+1D21",
        Glyph: "ᴡ",
        Description: "Latin Letter Small Capital W",
        TransliteratedCharacter: "W"
    },
    {
        Unicode: "U+FF38",
        Glyph: "Ｘ",
        Description: "Fullwidth Latin Capital Letter X",
        TransliteratedCharacter: "X"
    },
    {
        Unicode: "U+FF39",
        Glyph: "Ｙ",
        Description: "Fullwidth Latin Capital Letter Y",
        TransliteratedCharacter: "Y"
    },
    {
        Unicode: "U+028F",
        Glyph: "ʏ",
        Description: "Latin Letter Small Capital Y",
        TransliteratedCharacter: "Y"
    },
    {
        Unicode: "U+FF3A",
        Glyph: "Ｚ",
        Description: "Fullwidth Latin Capital Letter Z",
        TransliteratedCharacter: "Z"
    },
    {
        Unicode: "U+1D22",
        Glyph: "ᴢ",
        Description: "Latin Letter Small Capital Z",
        TransliteratedCharacter: "Z"
    },
    {
        Unicode: "U+009F",
        Glyph: "",
        Description: "<Control>",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0080",
        Glyph: "",
        Description: "C1 Control Codes",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+009B",
        Glyph: "",
        Description: "Control Sequence Introducer",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0014",
        Glyph: "",
        Description: "Device Control Four",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0011",
        Glyph: "",
        Description: "Device Control One",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0090",
        Glyph: "",
        Description: "Device Control String",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0013",
        Glyph: "",
        Description: "Device Control Three",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0012",
        Glyph: "",
        Description: "Device Control Two",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0019",
        Glyph: "",
        Description: "End Of Medium",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0003",
        Glyph: "",
        Description: "End Of Text",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0004",
        Glyph: "",
        Description: "End Of Transmission",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0017",
        Glyph: "",
        Description: "End Of Transmission Block",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0010",
        Glyph: "",
        Description: "Escape",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0009",
        Glyph: "	",
        Description: "Horizontal Tabulation",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+3000",
        Glyph: "　",
        Description: "Ideographic Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+205F",
        Glyph: " ",
        Description: "Medium Mathematical Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+202F",
        Glyph: "  ",
        Description: "Narrow No-Break Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+0000",
        Glyph: "�",
        Description: "Null",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+008D",
        Glyph: "",
        Description: "Reverse Line Feed",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2003",
        Glyph: "  ",
        Description: "Whitespace: Em Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2002",
        Glyph: " ",
        Description: "Whitespace: En Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2007",
        Glyph: "   ",
        Description: "Whitespace: Figure Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2005",
        Glyph: "   ",
        Description: "Whitespace: Four-Per-Em Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+200A",
        Glyph: "   ",
        Description: "Whitespace: Hair Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2028",
        Glyph: " ",
    Description: "Whitespace: Line Separator",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2001",
        Glyph: "     ",
        Description: "Whitespace: Medium Mathematical Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2029",
        Glyph: " ",
    Description: "Whitespace: Paragraph Separator",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2008",
        Glyph: "   ",
        Description: "Whitespace: Punctuation Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2006",
        Glyph: "   ",
        Description: "Whitespace: Six-Per-Em Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2009",
        Glyph: "  ",
        Description: "Whitespace: Thin Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2004",
        Glyph: "  ",
        Description: "Whitespace: Three-Per-Em Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+2060",
        Glyph: "⁠",
        Description: "Word Joiner",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+FEFF",
        Glyph: "﻿",
        Description: "Zero Width No-Break Space",
        TransliteratedCharacter: " "
    },
    {
        Unicode: "U+200B",
        Glyph: "​​​",
        Description: "Zero Width Space",
        TransliteratedCharacter: " "
    }
];
